import React from 'react';
import { string, number, shape, bool } from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { ThemeProvider } from '@one-thd/sui-atomic-components';
import { getThemeByName } from '@thd-olt-component-react/stencil-themes';
import { bentoHeroDataModel } from './bentoHeroDataModel';
import { BentoHeroContainer } from './BentoHeroContainer';

const BentoHero = ({
  componentId = '', componentClass = '', componentPosition = 1, livePreviewData = null, enableB2CRadius = false

}) => {
  const { data, loading, error } = useDataModel('component', {
    variables: {
      id: componentId,
      componentClass,
    }
  });

  const componentData = livePreviewData ? { ...livePreviewData, isLivePreviewData: true } : data;

  if (!componentData || loading || error) {
    return null;
  }

  return (
    <ImpressionProvider
      key={componentPosition}
      data={{
        id: componentId,
        component: BentoHero.displayName,
        name: BentoHero.displayName,
        type: 'content'
      }}
    >
      <ThemeProvider theme={getThemeByName(componentData?.component?.theme)}>
        <BentoHeroContainer data={componentData?.component || componentData} enableB2CRadius={enableB2CRadius} />
      </ThemeProvider>
    </ImpressionProvider>
  );
};

BentoHero.propTypes = {
  componentId: string,
  componentClass: string,
  componentPosition: number,
  livePreviewData: shape({}),
  enableB2CRadius: bool
};

BentoHero.displayName = 'BentoHero';

BentoHero.dataModel = bentoHeroDataModel;

export { BentoHero };
